module.exports = __webpack_public_path__ + "img/Banner2.b7923950.jpg";